import axios from "axios";
import { useEffect, useState } from "react";
import Select from "react-select";
import useStore from "../../store/useStore";
import { customStyleSelectCards } from "../../styles/styleSelect";
import { CostCenterOption, EmployeeCenterCostProps } from "./cardsTypes";

export function InputEmployeeByCenterCost() {
  const [costCenterOpt, setCostCenterOpt] = useState<CostCenterOption[]>([]);
  const [selectedOption, setSelectedOption] = useState<CostCenterOption | null>(null);
  const { centerCost, setCarPlate, setSelectedEmployee } = useStore((state) => state);

  useEffect(() => {
    setSelectedEmployee(selectedOption);
  }, [selectedOption, setSelectedEmployee]);

  useEffect(() => {
    (async function fetchData() {
      try {
        const { data } = await axios.get(
          `https://radar.tlpservicos.com.br/api/company/employees?cost_center=${centerCost?.value}`
        );
        setCostCenterOpt(
          data.map((item: EmployeeCenterCostProps) => ({
            value: item.nome,
            label: item.nome,
            centerCost: item.centro_custo,
            branch: item.filial,
            register: item.matricula,
            name: item.nome,
          }))
        );
      } catch (error) {
        console.error(error);
      }
    })();
  }, [centerCost]);

  useEffect(() => {
    (async function fetchData() {
      try {
        const { data } = await axios.get(
          `https://radar.tlpservicos.com.br/api/tracking/get-vehicle?branch=${selectedOption?.branch}&employee_number=${selectedOption?.register}`
        );
        if (data?.placa) {
          setCarPlate({
            value: data.placa,
            label: data.placa,
            plate: data.placa,
          });
        } else {
          setCarPlate({ value: "", label: "", plate: "" });
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [selectedOption, setCarPlate]);

  return (
    <div className=" bg-gray-50 dark:bg-gray-350 rounded-lg h-full flex flex-col overflow-visible">
      <div className=" bg-gray-100 dark:bg-gray-400 h-6 drag-handle cursor-move flex items-center px-2 rounded-t-md font-semibold text-sm">        Colaboradores
      </div>
      <div className="flex-grow flex flex-col justify-center px-1">
        <Select
          options={costCenterOpt}
          styles={customStyleSelectCards<CostCenterOption>()}
          placeholder="Colaboradores"
          isClearable
          isSearchable
          className="rounded-lg w-full text-sm"
          classNamePrefix="select"
          noOptionsMessage={() => "Nenhum centro de custo encontrado"}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          defaultValue={selectedOption}
          onChange={setSelectedOption}
        />
      </div>
    </div>
  );
}
